import { Spinner, SpinnerSize } from '@fluentui/react';
import { Page } from '../../../../grid/models/Page';
import { Pager } from '../../../../grid/views/Pager';
import { useOrderAdminVM } from '../../../viewmodels/OrderAdminVM';
import { useEffect, useRef } from 'react';
import OrderGridView from './OrderGridView';
import NewOrderView from '../../shared/NewOrderView';
import OrderDetailView from '../details/OrderDetailView';
import OrderFilterView from './OrderFilterView';
import OrderHeaderView from './OrderHeaderView';
import OrderHeaderCompactView from './OrderHeaderCompactView';

export default function OrderView() {
    const hasLoaded = useRef(false);
    const vm = useOrderAdminVM();
    const isMobile = window.innerWidth <= 500;

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        vm.onLoad();
    }, [vm]);

    const onShowFilter = () => {
        vm.tempSetFilter(vm.filter);
        vm.setShowFilter(true);
    };

    const onPageChange = (page: Page) => {
        if (page) {
            vm.filter.pageNumber = page.pageNumber;
            if (vm.filter.pageSize !== page.pageSize) vm.filter.pageNumber = 1;
            vm.filter.pageSize = page.pageSize;

            vm.getList(false, true);
        }
    };

    const onCompletedDetail = () => {
        if (window.confirm("Would you like to refresh the data?")) {
            vm.getList();
        }

        vm.setShowDetail(false);
    };

    const headerView = () => {
        const innerWidth = window.innerWidth;

        if (innerWidth <= 500) {
            return <OrderHeaderCompactView
                filter={vm.filter}
                statuses={vm.statuses}
                setStatuses={vm.setStatuses}
                onValueChange={vm.setFilterField}
                onGetList={vm.getList}
                setShowAdd={vm.setShowAdd}
                onShowFilter={onShowFilter}
            />
        }

        return <OrderHeaderView
            filter={vm.filter}
            statuses={vm.statuses}
            setStatuses={vm.setStatuses}
            onValueChange={vm.setFilterField}
            onGetList={vm.getList}
            setShowAdd={vm.setShowAdd}
            onShowFilter={onShowFilter}
        />;
    };

    return <div className="ms-Grid">
        <div className="ms-Grid-row center">
            {headerView()}
        </div>

        <div className={isMobile ? "" : "pt-20"}>
            {vm.loading && <div className="pt-10"><Spinner size={SpinnerSize.large} /></div>}

            <OrderGridView
                orders={vm.orders}
                key={vm.listHash}
                onDetail={(id: number) => {
                    vm.setShowDetail(true);
                    vm.setSelectedId(id);
                }}
                onPlaceOrder={vm.placeOrder}
                onCompleted={onCompletedDetail}
            />
        </div>

        <div style={{ width: "100%", display: "inline-block" }}>
            <Pager
                totalCount={vm.totalCount}
                onChange={onPageChange}
                pageSize={vm.filter.pageSize}
                key={vm.pageHash}
            />
        </div>

        {vm.showAdd && <>
            <NewOrderView isAdmin={true} onClose={() => vm.setShowAdd(false)} />
        </>}

        {vm.showDetail && <>
            <OrderDetailView
                id={vm.selectedId}
                userRoles={vm.userRoles}
                websiteOptions={vm.websites}
                onClose={() => {
                    vm.setShowDetail(false);
                    vm.getList();
                }}
            />
        </>}

        {vm.showFilter && <>
            <OrderFilterView
                form={vm.tempFilter}
                onClose={() => vm.setShowFilter(false)}
                onValueChange={vm.tempSetFilterField}
                onSubmit={() => {
                    vm.setFilter(vm.tempFilter);
                    vm.setShowFilter(false);
                    vm.getList();
                }}
            />
        </>}
    </div>;
}